import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconClipboardMinus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1666 3.54167H13.9416C13.8607 2.49667 13.1841 1.875 12.0833 1.875H7.91658C6.81575 1.875 6.1391 2.49667 6.05827 3.54167H5.83325C3.81825 3.54167 2.70825 4.65167 2.70825 6.66667V15C2.70825 17.015 3.81825 18.125 5.83325 18.125H14.1666C16.1816 18.125 17.2916 17.015 17.2916 15V6.66667C17.2916 4.65167 16.1816 3.54167 14.1666 3.54167ZM7.29158 3.75C7.29158 3.25917 7.42575 3.125 7.91658 3.125H12.0833C12.5741 3.125 12.7083 3.25917 12.7083 3.75V4.58333C12.7083 5.07417 12.5741 5.20833 12.0833 5.20833H7.91658C7.42575 5.20833 7.29158 5.07417 7.29158 4.58333V3.75ZM16.0416 15C16.0416 16.3142 15.4808 16.875 14.1666 16.875H5.83325C4.51909 16.875 3.95825 16.3142 3.95825 15V6.66667C3.95825 5.3525 4.51909 4.79167 5.83325 4.79167H6.05827C6.1391 5.83667 6.81575 6.45833 7.91658 6.45833H12.0833C13.1841 6.45833 13.8607 5.83667 13.9416 4.79167H14.1666C15.4808 4.79167 16.0416 5.3525 16.0416 6.66667V15ZM12.7083 11.25C12.7083 11.595 12.4283 11.875 12.0833 11.875H7.91658C7.57159 11.875 7.29158 11.595 7.29158 11.25C7.29158 10.905 7.57159 10.625 7.91658 10.625H12.0833C12.4283 10.625 12.7083 10.905 12.7083 11.25Z"
      fill={color}
    />
  </svg>
);

export default IconClipboardMinus;
